export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/editor/co-edit-alert-popup.jpg";